import React, { Component } from 'react';
import { prettifyDate } from '../../../utils/string';
import { statementsShape } from '../../../utils/propTypes';
import './StatementsListItem.scss';
import { get } from 'lodash';
import Actions from '../Actions/Actions';

export default class StatementsListItem extends Component {
    static propTypes = {
        item: statementsShape.isRequired
    };

    renderDate(date) {
        return date ? prettifyDate(date, { dateTimeFormatOutput: 'MMMM YYYY' }) : 'No Date';
    }

    render() {
        const statement = this.props.item;
        const merchantName = get(statement, 'merchantName', 'No Merchant');

        return (
            <div className="statements-list-item">
                <div className="statements-list-item-left">
                    <span className="statements-date">
                        {this.renderDate(statement.statementDate)}
                    </span>
                    <span className="statements-merchant">
                        {merchantName}
                    </span>
                </div>
                <div className="statements-list-item-right">
                    <Actions statement={statement} shouldControlToast shouldControlAction />
                </div>
            </div>
        );
    }
}
